import React, { useState } from 'react';
import axios from 'axios';

function YtTest() {
    const [url, setUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState(null);

    const handleTest = async (e) => {
        e.preventDefault();
        if (!url) return alert('Please enter a YouTube URL');

        setLoading(true);
        setResults(null);
        try {
            const { data } = await axios.post('/api/tools/yt-test', { url });
            setResults(data);
            alert('Successfully fetched from Invidious API!');
        } catch (error) {
            console.error('Test error:', error);
            alert(error.response?.data?.error || 'Failed to fetch video data');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 p-8">
            <div className="max-w-3xl mx-auto bg-white p-8 rounded-xl shadow-sm border border-gray-100">
                <h1 className="text-2xl font-bold text-gray-800 mb-2">YouTube Bypass Test</h1>
                <p className="text-gray-500 mb-8">
                    Testing Technique #1: <strong>Invidious API</strong>. This circumvents yt-dlp entirely.
                </p>

                <form onSubmit={handleTest} className="mb-8">
                    <div className="flex gap-4">
                        <input
                            type="text"
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            placeholder="https://www.youtube.com/watch?v=..."
                            className="flex-1 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        <button
                            type="submit"
                            disabled={loading}
                            className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 disabled:opacity-50"
                        >
                            {loading ? 'Testing...' : 'Test Download'}
                        </button>
                    </div>
                </form>

                {results && (
                    <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
                        <h2 className="text-lg font-semibold mb-4 text-green-600">Success! Found Direct Links</h2>
                        
                        <div className="space-y-3">
                            {results.streams?.map((stream, idx) => (
                                <div key={idx} className="flex items-center justify-between p-3 bg-white border border-gray-200 rounded">
                                    <div>
                                        <span className="font-bold text-gray-700">{stream.qualityLabel || stream.resolution || stream.quality}</span>
                                        <span className="text-sm text-gray-500 ml-2">({stream.type || stream.mimeType})</span>
                                    </div>
                                    <a 
                                        href={stream.url} 
                                        target="_blank" 
                                        rel="noreferrer"
                                        className="text-blue-600 hover:underline text-sm font-medium"
                                    >
                                        Direct Link
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default YtTest;
